export const DESIGNER_LOAD_ERROR = 'Unable to load this design. Please try again.';

export const runDesignerBootstrap = async (load, { setLoading, setError, notifyError }) => {
  setLoading(true);
  setError(null);
  try {
    await load();
    return true;
  } catch (error) {
    setError(DESIGNER_LOAD_ERROR);
    notifyError?.(DESIGNER_LOAD_ERROR);
    return false;
  } finally {
    setLoading(false);
  }
};
